import { AuthConfig } from 'angular-oauth2-oidc';
import { endPoints, environment, authRefreshTokenTimeoutFactor } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

const idpProviderOrigin: string =
  environment.name === 'dev'
    ? 'https://ui.d-lhr1-docker-034.dev.awin.com'
    : window.location.origin;

export const authConfig: AuthConfig = {
  issuer: 'ui.awin.com',
  skipIssuerCheck: true,
  redirectUri: window.location.origin + '/communication-centre/en/awin/oidc',
  silentRefreshRedirectUri:
    idpProviderOrigin + '/communication-centre/en/silent-refresh.html',
  tokenEndpoint: idpProviderOrigin + '/backend/idpbackend/token',
  clientId: 'communicationCentreUi',
  scope: 'openid ' +
    'user:readGatekeeper ' +
    'user:readAccountPermissions ' +
    'user:accounts:writeLinkBuilder ' +
    'provider:accounts:writeLinkBuilder ' +
    'provider:accounts:cc:accountProfile:read ' +
    'provider:accounts:cc:communications:read ' +
    'provider:accounts:cc:communications:write ' +
    'provider:accounts:cc:messages:read ' +
    'provider:accounts:cc:messages:write ' +
    'provider:accounts:cc:preferences:read ' +
    'provider:accounts:cc:preferences:write ' +
    'provider:accounts:cc:publisherSelector:read ' +
    '',
  loginUrl: idpProviderOrigin + '/backend/idpbackend/authorize',
  logoutUrl: idpProviderOrigin + '/login',
  postLogoutRedirectUri: idpProviderOrigin + '/communication-centre/en/awin/oidc',
  responseType: 'code',
  showDebugInformation: true,
  useSilentRefresh: true,
  timeoutFactor: authRefreshTokenTimeoutFactor,
};

export function customUrlValidation(url: string): boolean {
  const allowedUrls = [
    `/backend/account-permissions-api/`,
    `/backend/gatekeeper-api/`,
    `/backend/linkbuilder-api/`,

    `/backend/communication-centre-storage/`,
    `/backend/communication-centre-publisher-selector/`,
    `/backend/communication-centre-preferences/`,
  ];
  
  return allowedUrls.map((allowedUrl) => url.startsWith(idpProviderOrigin + allowedUrl)).some((v) => !!v);
}

export function configureOAuth(http: HttpClient) {
  return (): Promise<unknown> => {
    return http
      .get(idpProviderOrigin + endPoints.jwksUrl)
      .pipe(tap((jwk: Record<string, string>) => (authConfig.jwks = jwk)))
      .toPromise();
  };
}
